module.exports = __webpack_public_path__ + "img/img11.2869470a.jpg";